import { useEffect } from "react";

const CLASS_NAME = "is-any-popup-like-window-opened";

// Note: Use search through the project to find the usage cases.
const useRegulateGlobalClassNameIsAnyPopupLikeWindowOpened = (isWindowOpened) => {
  useEffect(() => {
    let isExited = false, isWasOpenedBefore, root;

    if (isWindowOpened) {
      // {setTimeout} is needed, because:
      // Open popup 1 -> locked for popup 1.
      // Open popup 2 without closing popup 1 -> locked for popup 2, unlocked for popup 1.
      setTimeout(() => {
        if (!isExited) {
          root = document.documentElement;

          if (root) {
            isWasOpenedBefore = root.classList.contains(CLASS_NAME);

            if (!isWasOpenedBefore) {
              root.classList.add(CLASS_NAME);
            }
          }
        }
      });
    }

    return () => {
      if (isWindowOpened) {
        isExited = true;

        if (!isWasOpenedBefore && root) {
          root.classList.remove(CLASS_NAME);
        }
      }
    };
  }, [isWindowOpened]);
};

export default useRegulateGlobalClassNameIsAnyPopupLikeWindowOpened;
